// GENERATED FILE - DO NOT MODIFY
import { ContactLookupModel } from "api/models/company/contact/contact-lookup-model";
import { ContactModel } from "api/models/company/contact/contact-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class SupplierContactProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetSupplierContacts(supplierId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactModel[] | null> {
        const uri = this.buildUri(
            "/suppliers/{supplierId}/contacts",
            { supplierId: (supplierId === null || supplierId === undefined) ? undefined : supplierId },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactModel[] | null = await this.get<ContactModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetSupplierContactsLookup(supplierId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel[] | null> {
        const uri = this.buildUri(
            "/Suppliers/{supplierId}/contacts/lookup",
            { supplierId: (supplierId === null || supplierId === undefined) ? undefined : supplierId },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactLookupModel[] | null = await this.get<ContactLookupModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }
}
